import type { ReactNode } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import AppShell from './components/AppShell/AppShell';

import { InstructorMarketingModal } from './components/InstructorMarketingModal/InstructorMarketingModal';
import MyCategoryModalWrapper from './components/MyCategoryModal/MyCategoryModal';
import WelcomeModalWrapper from './components/WelcomeModal/WelcomeModal';
import { routes } from './constants/routes';

const router = (rootElement: ReactNode) =>
  createBrowserRouter([
    {
      path: '',
      element: (
        <>
          <WelcomeModalWrapper />
          <MyCategoryModalWrapper />
          <InstructorMarketingModal />
          <AppShell />
          {rootElement}
        </>
      ),
      children: routes,
    },
  ]);

function App({ children = <Outlet /> }: { children?: ReactNode }) {
  return (
    <div id="App">
      <RouterProvider router={router(children)} />
    </div>
  );
}

export default App;
